import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { PasspordRequestUpdate } from "../users/usersSlice";
import { toast } from 'react-hot-toast';
import usePassportForm from "./usePassportForm";
import { useNavigate } from "react-router-dom";


const ReviewSubmit = ({ data, prev }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loadingData, setloadingData] = useState(false);

    const { clearForm } = usePassportForm();
    const handleSubmit = async () => {

        const submitFormData = new FormData();

        Object.keys(data).forEach((section) => {

            const sectionData = data[section];

            if (typeof sectionData === "object") {

                Object.keys(sectionData).forEach((key) => {

                    const value = sectionData[key];

                    // If file object wrapped
                    if (value?.file instanceof File) {
                        submitFormData.append(`${section}_${key}`, value.file);
                    }

                    // If direct file
                    else if (value instanceof File) {
                        submitFormData.append(`${section}_${key}`, value);
                    }

                    // normal fields
                    else if (value !== null && value !== undefined) {
                        submitFormData.append(`${section}_${key}`, value);
                    }

                });

            }

        });
        console.log("Final FormData:");
        for (let [key, value] of submitFormData.entries()) {
            console.log(key, value);
        }
        setloadingData(true)
        const response = await dispatch(
            PasspordRequestUpdate(submitFormData)
        ).unwrap();
        const Resultdata = response.data;
        console.log(Resultdata);
        if (Resultdata.status.success) {
            toast.success(Resultdata.message, {
                autoClose: 2000
            });
            // Clear form
            clearForm();
            // Navigate
            setloadingData(false)
            setTimeout(() => {
                navigate("/passport-request");
            }, 800);
            return false;
        } else {
            toast.error(Resultdata.message, { autoClose: 2000 });
            return false;
        }

    };


    return (
        <div>

            <h3 className="text-xl font-semibold mb-4">
                Review Application
            </h3>

            <div className="space-y-4 bg-gray-50 p-4 rounded">

                {Object.entries(data).map(([section, values]) => (
                    <div key={section}>

                        <h4 className="font-semibold capitalize">
                            {section}
                        </h4>

                        <div className="grid grid-cols-2 gap-2">

                            {Object.entries(values).map(([key, value]) => (
                                <div key={key}>
                                    <span className="font-medium">
                                        {key} :
                                    </span>{" "}
                                    {value?.name || value?.toString() || "-"}
                                </div>
                            ))}

                        </div>

                    </div>
                ))}

            </div>

            <div className="mt-6 flex justify-between">

                <button
                    onClick={prev}
                    className="btn-secondary"
                >
                    Back
                </button>

                <button
                    onClick={handleSubmit}
                    className="btn-primary"
                >
                    Submit Application
                </button>

            </div>

        </div>
    );
};

export default ReviewSubmit;




